import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'customTimer',
    standalone: true
})
export class CustomTimerPipe implements PipeTransform {
    public timerTranslations = {
        hours: this.translate.instant('general.timer.hours'),
        minutes: this.translate.instant('general.timer.minutes'),
        seconds: this.translate.instant('general.timer.seconds')
    };

    constructor(private datePipe: DatePipe, private translate: TranslateService) {}

    public transform(value: Date | string | number): string | null {
        const { hours: h, minutes: m, seconds: s } = this.timerTranslations;
        const format: string = `HH '${h}' mm '${m}' ss '${s}'`;
        return this.datePipe.transform(value, format);
    }
}
